import { render, staticRenderFns } from "./CustomerInvoiceList.vue?vue&type=template&id=ce5c8f02&scoped=true"
import script from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceList.vue?vue&type=style&index=0&id=ce5c8f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5c8f02",
  null
  
)

export default component.exports